import { Component, Input, ChangeDetectionStrategy, ElementRef, Renderer2 } from '@angular/core';
import { replaceClass } from '../util/util';
var NglAvatar = (function () {
    function NglAvatar(element, renderer) {
        this.element = element;
        this.renderer = renderer;
        this.src = '';
        this.alt = '';
        renderer.addClass(element.nativeElement, 'slds-avatar');
    }
    Object.defineProperty(NglAvatar.prototype, "setSize", {
        set: function (value) {
            this.updateClass(this._size, value);
            this._size = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NglAvatar.prototype, "setType", {
        set: function (value) {
            this.updateClass(this._type, value);
            this._type = value;
        },
        enumerable: true,
        configurable: true
    });
    NglAvatar.prototype.ngOnInit = function () {
        if (!this._type) {
            this.renderer.addClass(this.element.nativeElement, 'slds-avatar--rectangle');
        }
        if (!this._size) {
            this.renderer.addClass(this.element.nativeElement, 'slds-avatar--medium');
        }
    };
    NglAvatar.prototype.updateClass = function (oldValue, newValue) {
        replaceClass(this, "slds-avatar--" + oldValue, newValue ? "slds-avatar--" + newValue : '');
    };
    NglAvatar.decorators = [
        { type: Component, args: [{
                    selector: 'ngl-avatar',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: "\n    <img [src]=\"src\" [alt]=\"alt\">\n  ",
                },] },
    ];
    /** @nocollapse */
    NglAvatar.ctorParameters = function () { return [
        { type: ElementRef, },
        { type: Renderer2, },
    ]; };
    NglAvatar.propDecorators = {
        'src': [{ type: Input },],
        'alt': [{ type: Input },],
        'setSize': [{ type: Input, args: ['size',] },],
        'setType': [{ type: Input, args: ['type',] },],
    };
    return NglAvatar;
}());
export { NglAvatar };
;
//# sourceMappingURL=avatar.js.map